import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RelationState } from '../_reducers/relation.reducers';

const getRelationState = createFeatureSelector<RelationState>('relation');

export const getIsRelationTablesLoading = createSelector(
  getRelationState,
  (state: RelationState) => state.isRelationTablesLoading
);

export const getRelationsLoading = createSelector(
  getRelationState,
  (state: RelationState) => state.relationsLoading
);

export const getRelationLoading = createSelector(
  getRelationState,
  (state: RelationState) => state.relationLoading
);

/**
 * Select relations
 */
export const getRelations = createSelector(
  getRelationState,
  (state: RelationState) => state.relations
);

export const getApplicationRelations = createSelector(
  getRelationState,
  (state: RelationState) => state.applicationRelations
);

/**
 * Select single relation
 */
export const getRelation = createSelector(
  getRelationState,
  (state: RelationState) => state.relation
);

/**
 * Select validate relation
 */
export const getValidateRelation = createSelector(
  getRelationState,
  (state: RelationState) => state.validate
);

/**
 * Select operations
 */
export const getRelationOperations = createSelector(
  getRelationState,
  (state: RelationState) => state.operations
);

/**
 * Select relation tables
 */
export const getRelationTables = createSelector(
  getRelationState,
  (state: RelationState) => state.tables
);

/**
 * Select error
 */
export const getTableError = createSelector(
  getRelationState,
  (state: RelationState) => state.error
);
